import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { api_refresh_access_token } from ".";

// initState
const initialState = {
  //token 정보들
  userId: "",
  accessToken: "",
};

// Reducer

export interface tokenInterface {
  userId: string;
  accessToken: string;
}

export const tokenSlice = createSlice({
  name: "token",
  initialState,
  reducers: {
    setToken: (state, action: PayloadAction<tokenInterface>) => {
      // if (action.payload.userId !== undefined) {
      state.userId = action.payload.userId;
      // }
      // if (action.payload.accessToken) {
      state.accessToken = action.payload.accessToken;
      // }
    },
    refreshToken: (state) => {
      //1. api에서 받아옴
      api_refresh_access_token({ userId: state.userId })
        .then((response) => {
          //2. 결과값을 state에 넣음
          if ("new_accessToken" in response) {
            state.accessToken = response["new_accessToken"];
          }
        })
        .catch((error) => {
          console.log("====refreshToken====");
          console.log(error);
        });
    },
  },
});

export const { setToken, refreshToken } = tokenSlice.actions;
export const tokenReducer = tokenSlice.reducer;
